module.exports = __webpack_public_path__ + "static/img/0102_01234.754baed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/01/0102_01234.png
// module id = tDy0
// module chunks = 1